import React from 'react'
import './About.css';

const About = () => {
  return (
    <div className='about'>
        <div className='leftSide'></div>
        <div className='rightSide'>
            <h1>About Us</h1>
            <p>We believe fitness should be accessible to everyone, everywhere, regardless of income level or access to a gym. 
                That's why we offer hundreds of free, full-length workout videos, the most effective workout programs on the web and fitness information.</p>


        </div>
    </div>
  )
}

export default About